import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import TextEditor, {TextEditorContainer} from 'lib/ui/form/TextEditor'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function BodyConfig() {
  const {techCheck} = useTemplate()
  const save = useSaveTemplate()
  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()

  const {
    form: {control},
  } = useConfig()

  const handleSave = (data: any) => {
    const body = replaceAtPath(data, 'techCheck.body', '{{tech_check_body}}')
    save({
      ...data,
      localization: addTranslation({
        tech_check_body: body ?? '',
      }),
    })
  }

  return (
    <Config title="Body" onSave={handleSave}>
      <SettingsPanel>
        <TextEditorContainer>
          <Controller
            name="techCheck.body"
            defaultValue={v(techCheck.body)}
            control={control}
            render={({value, onChange}) => (
              <TextEditor data={value} onChange={onChange} />
            )}
          />
        </TextEditorContainer>
      </SettingsPanel>
    </Config>
  )
}
